import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BACKEND_URL } from "../lib/api";

/** Public page for external token access (no auth required). */
export default function ExternalAccess() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/external/access/${token}`)
      .then(async (r) => {
        if (!r.ok) { setError((await r.json()).detail || "Token inválido"); return; }
        setData(await r.json());
      })
      .catch((e) => setError(e.message));
  }, [token]);

  if (error) return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 20 }}>
      <div className="card" style={{ maxWidth: 500, textAlign: "center" }}>
        <h2 className="card-h1 text-danger">Acceso denegado</h2>
        <p className="text-dim">{error}</p>
      </div>
    </div>
  );
  if (!data) return <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}><div className="spinner" /></div>;

  return (
    <div style={{ minHeight: "100vh", padding: "40px 20px", background: "var(--bg-0)" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div className="card mb-4">
          <div className="card-title">Acceso externo · {data.tenant_name}</div>
          <h1 className="card-h1">{data.label}</h1>
          <div className="text-xs text-dim">Módulo: {data.module}</div>
        </div>

        {data.type === "list" && data.rows && (
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>{Object.keys(data.rows[0] || {}).filter(k => !["_id","tenant_id","id","created_at","updated_at","created_by","updated_by"].includes(k)).map((k) => <th key={k}>{k}</th>)}</tr>
              </thead>
              <tbody>
                {data.rows.map((r, i) => (
                  <tr key={i}>
                    {Object.keys(data.rows[0] || {}).filter(k => !["_id","tenant_id","id","created_at","updated_at","created_by","updated_by"].includes(k)).map((k) => <td key={k}>{String(r[k] ?? "-").slice(0, 80)}</td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {data.type === "record" && data.record && (
          <div className="card">
            <pre style={{ whiteSpace: "pre-wrap", fontSize: 12 }}>{JSON.stringify(data.record, null, 2)}</pre>
          </div>
        )}

        {data.type === "report" && (
          <div className="card text-center">
            <h2>Reporte: {data.report}</h2>
            <p className="text-dim mt-3">Reporte disponible. Contacta al administrador para recibir el PDF.</p>
          </div>
        )}
      </div>
    </div>
  );
}
